import React, { useContext, useState } from "react";
import { handleApiErrors, InputType,} from "../../Utils/Utils";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CoordinatorSidebar from "../CoordinatorSidebar/CoordinatorSidebar";
import CoordinatorNavbar from "../CoordinatorNavbar/CoordinatorNavbar";
import DataProvider from "../../Utils/DataProvider";
import { AuthContext } from "../../Context/authContext";
import { SvgImages } from "../../Utils/LocalImages";
import ApiConstants from "../../Utils/ApiConstant";
import Image from "../../Components/Reusable/Image";
import { useForm } from "react-hook-form";
import SessionManager from "../../Utils/Session";
import { toast } from "react-toastify";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";


const Profile = ({ show }) => {
    const { coordinator } = useContext(AuthContext);
    const removeTimeFromDate = (dateString) => {
      if (!dateString) return '';
      const dateObject = new Date(dateString);
      // Ensure the date is parsed as UTC
      const utcYear = dateObject.getUTCFullYear();
      const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
      const utcDay = dateObject.getUTCDate();
      return `${utcDay} ${utcMonth} , ${utcYear}`;
  
    };
  
    const { register: registerDetails, handleSubmit: handleSubmitDetails, setValue: setUserValues, formState: { errors: errorsDetails } } = useForm({
      defaultValues: {
        name: coordinator?.name || '',
        email: coordinator?.email || '',
        mobile_number: coordinator?.mobile || '',
        dateOfBirth: removeTimeFromDate(coordinator?.dateOfBirth) || '',
      },
    });

    const coupdateProfileDetails = async (file) => {
      try {
        const response = await CoordinatorApiServices.coupdateProfileDetails(file);
        // setShowConfirmationModal(true);  
        toast.success("Profile Pic Updated Successfully!");
        SessionManager.shared.storeCoordinatorData(response.coordinator);
        setUserValues("name", response.coordinator?.name?.trim())
        setUserValues("mobile", response.coordinator?.mobile?.trim())
        setUserValues("email", response.coordinator?.email?.trim())
      } catch (error) {
        handleApiErrors(error);
      }
    };
  return (
    <div className="d-flex">
    <CoordinatorSidebar />
    <div className="mainLayout-content">
        <CoordinatorNavbar />
        <div className="main_content_two contentSection scroll_bar cofocus">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0">My Profile</h1>
          </div>
          <form >
        <div className=" d-flex flex-column p-0">

          <div className="d-flex flex-column gap-3 justify-content-center mt-4">
            <div className="mb-0 d-flex justify-content-center select_profile_img">
              <CustomTextFieldTwo id="file" type="file" className="d-none" />
              <Image className="modal_profile" id="output" style={{ objectFit: "cover" }}
                 src={coordinator?.profilePicture && coordinator.profilePicture?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + coordinator.profilePicture : SvgImages.user_profile}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = SvgImages.user_profile;
                }} />
              <div className="position-relative">
                <a className="secondary  fs-16 fw-500 coedit_img d-flex justify-content-center align-items-center" >
                  <Image src={SvgImages.camera} />
                </a>

                <input type="file" className="coedit_img opacity-0" multiple={false} accept="image/*" name="fileupload"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      coupdateProfileDetails(e.target.files[0]);
                    }
                  }} />
              </div>
            </div>
          
            <div className="d-flex flex-column text-center ">
              <h3 className="medium-text fw-700">{coordinator?.name?.trim()}</h3>
              <h3 className="orangeAccentColor small-medium-text fw-600">{coordinator.referralCode}</h3>
            </div>
          </div>
        
          <div className="mb-4  mt-4 d-flex justify-content-between align-items-center">
            <h1 className="blue medium-text fw-700 mb-0">Personal Details</h1>
          </div>
          <div className="row profile_inputs w-100">
            <div className="col-md-6">
              <CustomTextFieldTwo
                labelTitle="Name"
                placeholder="Name"
                defaultValue={coordinator?.name || ''} // Use defaultValue to set initial value
                    {...registerDetails("name")}
                disabled={true}
                additionalClasses="coprofile_edit"
                 labelClass="TextInput"
                
              />
            </div>

            <div className="col-md-6">
              <CustomTextFieldTwo
                labelTitle="Email Id"
                placeholder="Email Id"
                defaultValue={coordinator?.email || ''} // Use defaultValue to set initial value
                    {...registerDetails("email")}
                disabled={true}
                 labelClass="TextInput"
                additionalClasses="coprofile_edit"
                
              />
            </div>

            <div className="col-md-6">
              <CustomTextFieldTwo
                labelTitle="Mobile No."
                placeholder="Mobile No."
                defaultValue={coordinator?.mobile || ''} // Use defaultValue to set initial value
                {...registerDetails("mobile_number")}
                disabled={true}
                 labelClass="TextInput"
                additionalClasses="coprofile_edit"
                
              />
            </div>
            
            <div className="col-md-6">
              <CustomTextFieldTwo
                labelTitle="Date Of Birth"
                placeholder="Date Of Birth"
                defaultValue={removeTimeFromDate(coordinator?.dateOfBirth) || ''} // Use defaultValue to set initial value
                {...registerDetails("dateOfBirth")}
                disabled={true}
                labelClass="TextInput"
                additionalClasses="coprofile_edit"
                
              />
            </div>
          </div>
        

          {/* <div className="d-flex justify-content-between align-items-center">
            <a className="back_login m-0 cursor-pointer" onClick={() => window.history.back()}>
              <Image src={SvgImages.back_arrow_login} className="m-0" />
              Back
            </a>
            <div className="select-btn ">
              <ButtonWithIcon text={"Update"} icon={SvgImages.tick_mark} onClick={handleSubmitDetails(handleChangeDetails)} />
            </div>
          </div> */}
        </div>
      </form>
        </div>
        </div>
        </div>
  );
};

export default Profile;

